import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';

import CustomBox from '../common/CustomBox';
import { MAX_WITH_MOBILE_MEDIA } from '../../config/getTheme';
import './MetricWidget.scss';

const MetricWidget = props => {
  return (
    <CustomBox
      className='MetricWidgetComponent'
      onClick={props.onClick}
    >
      <Stack spacing={0.5} padding={1} paddingTop={3} alignItems='center'>
        <Badge
          className='MetricWidget__badge'
          color='secondary'
          overlap='circular'
          badgeContent={props.count}
          sx={{
            '& .MuiBadge-badge': {
              minWidth: "2.2275rem",
              height: "2.2275rem",
              borderRadius: "24px",
              fontSize: "1.5rem",
              fontWeight: 400,
              lineHeight: "1.03125rem",
              letterSpacing: "-0.02344rem",
              paddingBottom: "2px",
              top: "7%",
              right: "4%",
              [MAX_WITH_MOBILE_MEDIA]: {
                minWidth: "1.375rem",
                height: "1.375rem",
                fontSize: "0.8125rem",
                paddingBottom: "0"
              },
            },
          }}
        >
          <Stack alignItems='center' justifyContent='center' className='MetricWidget__circle'>
            <props.Icon color='primary' />
          </Stack>
        </Badge>
        <Typography
          variant='h2Inter'
          color='text.primary'
          sx={{
            lineHeight: 'normal',
            marginBottom: '6px !important',
            [MAX_WITH_MOBILE_MEDIA]: {
              fontSize: '0.875rem',
            },
          }}
        >
          {props.title}
        </Typography>
        <Typography
          variant='smallInter'
          color='text.light'
          sx={{
            lineHeight: 'normal',
            [MAX_WITH_MOBILE_MEDIA]: {
              display: 'none'
            },
          }}
          className='MetricWidget__description'
        >
          {props.countLabel ? props.countLabel.replace('{count}', props.count) : ''}
        </Typography>
      </Stack>
    </CustomBox>
  );
};

export default MetricWidget;
